import { Typography } from '@surveycake/rc';
import React, { memo } from 'react';
import { useStyles } from './styles';

export interface ProgressProps {
  percentage: number;
}

function Progress({ percentage }: ProgressProps) {
  const styles = useStyles();
  const transform = `scaleX(${percentage / 100})`;
  const style = {
    transform,
    msTransform: transform
  };

  return (
    <div className={styles.progressContainer}>
      <div className={styles.progress}>
        <div className={styles.track} style={style} />
      </div>
      <Typography className={styles.percentage} variant="span" color="primary">
        {percentage}%
      </Typography>
    </div>
  );
}

export default memo(
  Progress,
  (prev, next) => prev.percentage === next.percentage
);
